export type GoogleAddress = {
  address: string;
  postalCode: string;
  city: string;
  country: string;
  shortCountry: string;
};

type AddressFields = GoogleAddress;

type ComponentHandler = (
  component: google.maps.GeocoderAddressComponent,
  fields: AddressFields
) => void;

const componentHandlers: Record<string, ComponentHandler> = {
  street_number: (component, fields) => {
    fields.address = `${component.long_name} ${fields.address}`;
  },
  route: (component, fields) => {
    fields.address += component.short_name;
  },
  postal_code: (component, fields) => {
    fields.postalCode = `${component.long_name}${fields.postalCode}`;
  },
  postal_code_suffix: (component, fields) => {
    fields.postalCode = `${fields.postalCode}-${component.long_name}`;
  },
  locality: (component, fields) => {
    fields.city = component.long_name;
  },
  country: (component, fields) => {
    fields.country = component.long_name;
    fields.shortCountry = component.short_name;
  },
};

export const getAddressFromGeocoderAddressComponent = (
  addressComponents: google.maps.GeocoderAddressComponent[]
): GoogleAddress => {
  const fields: AddressFields = {
    address: '',
    postalCode: '',
    city: '',
    country: '',
    shortCountry: '',
  };

  for (const component of addressComponents) {
    const handler = componentHandlers[component.types[0]];
    handler?.(component, fields);
  }

  return fields;
};
